import type { InstalledExtension } from '../types';
import { matchesPattern } from './urls';

export function scriptsForUrl(extensions: InstalledExtension[], url: string): string[] {
  const scripts: string[] = [];
  for (const extension of extensions) {
    if (!extension.enabled) continue;
    for (const content of extension.manifest.content_scripts || []) {
      if (!content.matches.some((pattern) => matchesPattern(url, pattern))) continue;
      for (const scriptName of content.js) {
        const code = extension.scripts[scriptName];
        if (code) scripts.push(code);
      }
    }
  }
  return scripts;
}

export function parseExtensionPackage(source: string): { manifest: InstalledExtension['manifest']; scripts: Record<string, string> } {
  const parsed = JSON.parse(source) as { manifest: InstalledExtension['manifest']; scripts?: Record<string, string> };
  if (!parsed.manifest || parsed.manifest.manifest_version !== 3) throw new Error('Only manifest_version 3 packages are supported.');
  if (!parsed.manifest.name || !parsed.manifest.version) throw new Error('Extension manifest requires name and version.');
  return { manifest: parsed.manifest, scripts: parsed.scripts || {} };
}
